const consultantSearchBlock = (() => {
    
    let pagingInit = false;

    const initBlock = ((el) => {
        handleSearch(el);
        handlePaging(el);
    });

    const handlePaging = (el) => {
        const paging = el.querySelector('[data-paging]');
        if (paging) {
            paging.classList.remove('hidden');
            const prevButton = paging.querySelector('button[title="Previous Page"]');
            const nextButton = paging.querySelector('button[title="Next Page"]');
            const currentPage = parseInt(paging.dataset.currentPage);
            let totalPages = parseInt(paging.dataset.totalPages);
            updateButtons(el, prevButton, nextButton, currentPage, totalPages);
            if (prevButton && nextButton && pagingInit === false) {
                prevButton.addEventListener('click', () =>
                    handlePagingButton(el, paging, (parseInt(paging.dataset.currentPage) - 1), totalPages, nextButton, prevButton));
                nextButton.addEventListener('click', () =>
                    handlePagingButton(el, paging, (parseInt(paging.dataset.currentPage) + 1), totalPages, nextButton, prevButton));
                pagingInit = true;
            }
        }
    };

    const handlePagingButton = (el, paging, newPage, totalPages, nextButton, prevButton) => {
        const resultsWrapper = el.querySelector('[data-results]');
        const currentValueElement = paging.querySelector('[data-current-value]');
        const searchValues = getSearchValues(el);
        const pageSize = el.querySelector('[data-page-size]').dataset.pageSize;
        const pageId = el.querySelector('[data-page-id]').dataset.pageId;
        if (currentValueElement) currentValueElement.dataset.currentValue = newPage;
        paging.dataset.currentPage = newPage;
        fetch(`/umbraco/surface/ClinicianResults/GetFilteredConsultantSearchBlock?currentPage=${newPage}&name=${searchValues.name}&condition=${searchValues.condition}&ageGroup=${searchValues.ageGroup}&type=${searchValues.type}&pageSize=${pageSize}&pageId=${pageId}`)
            .then(response => response.text())
            .then(data => {
                if (resultsWrapper) {
                    resultsWrapper.innerHTML = data;
                    const paging = el.querySelector('[data-paging]');
                    const newTotalPagesElement = resultsWrapper.querySelector('[data-results-total-pages]');
                    if (newTotalPagesElement) {
                        const newTotalPages = newTotalPagesElement.dataset.resultsTotalPages;
                        paging.dataset.totalPages = newTotalPages;
                        totalPages = parseInt(paging.dataset.totalPages);
                    }
                    updateButtons(el, prevButton, nextButton, newPage, totalPages);
                    el.scrollIntoView({behavior: "smooth"});
                }
            });
    }

    const getSearchValues = (el) => {
        const search = el.querySelector('[data-consultant-search]');
        const nameWrapper = search.querySelector('[data-consultant-search-name]');
        const conditionWrapper = search.querySelector('[data-consultant-search-condition]');
        const ageGroupWrapper = search.querySelector('[data-consultant-search-agegroup]');
        const typeWrapper = search.querySelector('[data-consultant-search-type]');
        return {
            name: nameWrapper.querySelector('input').value,
            condition: conditionWrapper.querySelector('select').value,
            ageGroup: ageGroupWrapper.querySelector('select').value,
            type: typeWrapper.querySelector('select').value
        }
    };

    const handleSearch = (el) => {
        const resultsWrapper = el.querySelector('[data-results]');
        const search = el.querySelector('[data-consultant-search]');
        if (search) {
            const buttonWrapper = search.querySelector('[data-consultant-search-button]');
            const button = buttonWrapper.querySelector('button');
            button.addEventListener('click', (() => {
                const paging = el.querySelector('[data-paging]');
                if (paging) {
                    const prevButton = paging.querySelector('button[title="Previous Page"]');
                    const nextButton = paging.querySelector('button[title="Next Page"]');
                    const currentPage = 1;
                    let totalPages = parseInt(paging.dataset.totalPages);
                    const searchValues = getSearchValues(el);
                    const pageSize = el.querySelector('[data-page-size]').dataset.pageSize;
                    const pageId = el.querySelector('[data-page-id]').dataset.pageId;
                    fetch(`/umbraco/surface/ClinicianResults/GetFilteredConsultantSearchBlock?currentPage=${currentPage}&name=${searchValues.name}&condition=${searchValues.condition}&ageGroup=${searchValues.ageGroup}&type=${searchValues.type}&pageSize=${pageSize}&pageId=${pageId}`)
                        .then(response => response.text())
                        .then(data => {
                            if (resultsWrapper) {
                                resultsWrapper.innerHTML = data;
                                const newTotalPagesElement = resultsWrapper.querySelector('[data-results-total-pages]');
                                if (newTotalPagesElement) {
                                    const newTotalPages = newTotalPagesElement.dataset.resultsTotalPages;
                                    paging.dataset.totalPages = newTotalPages;
                                    totalPages = parseInt(paging.dataset.totalPages);
                                }
                                paging.dataset.currentPage = "1";
                                updateButtons(el, prevButton, nextButton, currentPage, totalPages);
                                handlePaging(el);
                                el.scrollIntoView({behavior: "smooth"});
                                const results = resultsWrapper.querySelectorAll('.search-results-block__results__wrapper__result').length;
                                if (results === 0){
                                    paging.classList.add('hidden');
                                    resultsWrapper.innerHTML += `<span>No Results Found</span>`
                                }else{
                                    paging.classList.remove('hidden');
                                }
                            }
                        })
                }
            }));
        }
    };

    const updateButtons = (el, prevButton, nextButton, currentPage, totalPages) => {
        if (currentPage === 1) {
            prevButton.setAttribute('disabled', '');
            prevButton.classList.add('disabled');
        } else {
            prevButton.removeAttribute('disabled');
            prevButton.classList.remove('disabled');
        }
        if (currentPage === totalPages) {
            nextButton.setAttribute('disabled', '');
            nextButton.classList.add('disabled');
        } else {
            nextButton.removeAttribute('disabled');
            nextButton.classList.remove('disabled');
        }
        const paging = el.querySelector('[data-paging]');
        if (paging) {
            const currentValueElement = paging.querySelector('[data-current-value]');
            const totalValueElement = paging.querySelector('[data-total-value]');
            if (currentValueElement && totalValueElement) {
                currentValueElement.dataset.currentValue = currentPage;
                totalValueElement.dataset.totalValue = totalPages;
            }
        }
    }

    return {initBlock};
})();

ControlBinders.register(`.consultant-search-block`, el => consultantSearchBlock.initBlock(el));